export enum ValidationSessionStateEnum {
    incomplete = 0,
    rejected = 1,
    validated = 2,
}
